import Route from '@ember/routing/route';

export default class ClassGroupIntermediateRoute extends Route 
{
	model(params) 
	{
		return params.split_name;
	}
}
